import DefaultMenu from "@/templates/default/Menu"
import ModernMenu from "@/templates/modern/Menu"
import ElegantMenu from "@/templates/elegant/Menu"
import VibrantMenu from "@/templates/vibrant/Menu"
import MinimalMenu from "@/templates/minimal/Menu"

export type ThemeName = "default" | "modern" | "elegant" | "vibrant" | "minimal"

const THEMES = {
  default: DefaultMenu,
  modern: ModernMenu,
  elegant: ElegantMenu,
  vibrant: VibrantMenu,
  minimal: MinimalMenu,
}

export const THEME_NAMES: ThemeName[] = ["default", "modern", "elegant", "vibrant", "minimal"]

export const THEME_DESCRIPTIONS: Record<ThemeName, string> = {
  default: "Design Padrão - Clássico e funcional",
  modern: "Design Moderno - Minimalista e limpo",
  elegant: "Design Elegante - Sofisticado e premium",
  vibrant: "Design Vibrante - Colorido e divertido",
  minimal: "Design Minimal - Preto e branco, alta clareza",
}

export function getThemeComponent(themeName?: string | null): React.ComponentType<any> {
  const normalizedTheme = (themeName?.toLowerCase() || "default") as ThemeName

  // Retornar o tema se existir, senão retornar o padrão
  return THEMES[normalizedTheme] || THEMES.default
}

export function isValidTheme(theme: string): theme is ThemeName {
  return theme in THEMES
}
